import { NBSP } from 'shared/constants/symbols';

export const LIST = [
  {
    image: 'up',
    title: `Рост спроса на${NBSP}рынке недвижимости`,
    descrList: [
      'Увеличение выручки за счёт лидогенерации для застройщиков',
      `Рост цен на недвижимость приводит к росту комиссии агентов/агентств, что стимулирует рост выручки Циан`,
    ],
  },
  {
    image: 'down',
    title: `Снижение спроса на${NBSP}рынке недвижимости`,
    descrList: [
      'Рост выручки за счёт размещения объявлений — увеличиваются сроки экспозиции объектов и спрос на платное продвижение',
    ],
  },
];

export const DESCRIPTION = [
  {
    value: `Циан работает по принципу самоподдерживающегося цикла, чем делает его устойчивым к рыночным колебаниям и${NBSP}обеспечивает стабильный рост.`,
  },
];
